import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Pesquisa } from '../../models/pesquisa';
import { AbstractPesquisaProvider } from '../../providers/pesquisa/abstract-pesquisa.provider';
import { MessageProvider } from '../../providers/message.provider';
import {AbstractLoading} from '../../pages/abstract-loading';
import {Util} from '../../utils/util';

@Component({
    selector: 'app-selecao-pesquisa',
    templateUrl: './selecao-pesquisa.page.html',
    styleUrls: ['./selecao-pesquisa.page.scss']
})
export class SelecaoPesquisaPage extends AbstractLoading {

    @Input() pesquisaProvider: AbstractPesquisaProvider;
    @Input() selecaoMultipla = false;
    @Input() showPesquisa = true;

    public lista: Array<Pesquisa>;
    public filtro: string;
    public itemMarcado: string | number;

    constructor(
        private modalController: ModalController,
        private messageProvider: MessageProvider
    ) {
        super();
    }

    getLista() {
        if (this.showPesquisa && this.filtro) {
            return this.lista.filter(item => Util.indexOfSemAcentos(item.descricao, this.filtro));
        } else {
            return this.lista;
        }
    }

    getServico() {
        return this.pesquisaProvider.getServico();
    }

    preencherDados(dados: any) {
        this.lista = this.pesquisaProvider.preencherDados(dados);
    }

    async confirmar() {
        if (this.selecaoMultipla) {
            const itensSelecionados = this.lista.filter((item: any) => {
                return item.marcado;
            });

            if (itensSelecionados.length === 0) {
                this.messageProvider.showToast('Selecione pelo menos um item.');
                return;
            }

            await this.modalController.dismiss(itensSelecionados.map((item: any) => {
                return item.objeto;
            }));
        } else {
            if (!this.itemMarcado) {
                this.messageProvider.showToast('Selecione um item.');
                return;
            }

            await this.modalController.dismiss(this.lista.find((item: any) => {
                return item.codigo == this.itemMarcado;
            }).objeto);
        }
    }

    async fechar() {
        await this.modalController.dismiss();
    }

}
